module.exports = __webpack_public_path__ + "static/img/C4D0036.5be32f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0036.jpg
// module id = AL+S
// module chunks = 0